export type { ToastFooterProps, ToastFooterSlots, ToastFooterState } from '@fluentui/react-toast';
